function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable */
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function ErrorComponent(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: "420px",
    height: "320px",
    viewBox: "0 0 420 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "100%",
        id: "error_svg__d",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F5F5F5",
          offset: "0%"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#CECBCB",
          offset: "100%"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "100%",
        id: "error_svg__b",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F5F5F5",
          stopOpacity: 0.433,
          offset: "0%"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#666",
          offset: "100%"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        x1: "50%",
        y1: ".995%",
        x2: "50%",
        y2: "99.43%",
        id: "error_svg__e",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#CCC",
          stopOpacity: 0,
          offset: "0%"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#666",
          offset: "100%"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        x1: "50%",
        y1: ".995%",
        x2: "50%",
        y2: "99.43%",
        id: "error_svg__f",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#CCC",
          stopOpacity: 0,
          offset: "0%"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#666",
          offset: "100%"
        })]
      }), /*#__PURE__*/_jsx("path", {
        id: "error_svg__a",
        d: "M106.228 77h207.285L412 124H9z"
      }), /*#__PURE__*/_jsx("mask", {
        id: "error_svg__c",
        maskContentUnits: "userSpaceOnUse",
        maskUnits: "objectBoundingBox",
        x: 0,
        y: 0,
        width: 403,
        height: 47,
        fill: "#fff",
        children: /*#__PURE__*/_jsx("use", {
          xlinkHref: "#error_svg__a"
        })
      })]
    }), /*#__PURE__*/_jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("use", {
        stroke: "url(#error_svg__b)",
        mask: "url(#error_svg__c)",
        strokeWidth: 2,
        fill: "url(#error_svg__d)",
        opacity: 0.211,
        strokeDasharray: 2,
        xlinkHref: "#error_svg__a"
      }), /*#__PURE__*/_jsx("path", {
        d: "M107.54 245.5l-93.989 27h396.853l-95.205-27H107.54z",
        stroke: "#CCC",
        fill: "#F9F9F9"
      }), /*#__PURE__*/_jsx("path", {
        d: "M306.5 240.5V256a4.5 4.5 0 004.5 4.5h8a4.5 4.5 0 004.5-4.5v-15.5h-17z",
        stroke: "#CCC",
        fill: "#F5F5F5"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FFF",
        d: "M307 241h16v4h-16z"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#CCC",
        fill: "#EBEBEB",
        d: "M308.5 250.5h4v4h-4z"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#CCC",
        fill: "#D8D8D8",
        d: "M310.5 241.5h1v8h-1z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M324 254h2a3 3 0 003-3v-4a3 3 0 00-3-3h-2v10z",
        stroke: "#CCC",
        fill: "#FFF"
      }), /*#__PURE__*/_jsx("path", {
        d: "M290.5 265.5h25c0-4.93-5.569-9-12.5-9s-12.5 4.07-12.5 9z",
        stroke: "#CCC",
        fill: "#F5F5F5"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#error_svg__e)",
        opacity: 0.49,
        transform: "matrix(-1 0 0 1 203 0)",
        d: "M101 120h1v139h-1z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M348 263h-1V113h1v150zm0 9v15h-1v-15h1z",
        fill: "url(#error_svg__f)",
        opacity: 0.49
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#CCC",
        fillOpacity: 0.125,
        fill: "#CCC",
        opacity: 0.2,
        d: "M350.5 43.5h-40v47h40zM164.5 43.5h-40v47h40zM292.5 43.5h-40v47h40zM105.5 43.5h-40v47h40z"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#CCC",
        fillOpacity: 0.143,
        fill: "#FFF",
        opacity: 0.702,
        d: "M189.5 48.5h40v47h-40z"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#CCC",
        fillOpacity: 0.125,
        fill: "#CCC",
        opacity: 0.2,
        d: "M224.5 43.5h-30v47h30z"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#CCC",
        fillOpacity: 0.143,
        fill: "#FFF",
        opacity: 0.702,
        d: "M72.5 48.5h40v47h-40zM287.5 48.5h-40v47h40zM345.5 48.5h-40v47h40zM130.5 48.5h40v47h-40z"
      }), /*#__PURE__*/_jsxs("g", {
        transform: "translate(125 116)",
        children: [/*#__PURE__*/_jsx("rect", {
          stroke: "#CCC",
          fill: "#FFF",
          x: 0.5,
          y: 0.5,
          width: 173,
          height: 117.125,
          rx: 6
        }), /*#__PURE__*/_jsx("path", {
          d: "M.5 101.125v11a5.5 5.5 0 005.5 5.5h162a5.5 5.5 0 005.5-5.5v-11H.5z",
          stroke: "#CCC",
          fill: "#F5F5F5"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F5F5F5",
          d: "M7.616 7.656h158.767v86.406H7.616z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M70.553 36.793A21.644 21.644 0 0065.267 51c0 12.003 9.73 21.733 21.733 21.733 4.247 0 8.31-1.22 11.792-3.474a3.93 3.93 0 01-.213-.227l-28.026-32.24zm6.048-4.882l27.84 32.026.013.016A21.632 21.632 0 00108.734 51c0-12.003-9.731-21.733-21.734-21.733-3.687 0-7.239.919-10.4 2.644zM87 80.5c-16.292 0-29.5-13.208-29.5-29.5S70.708 21.5 87 21.5s29.5 13.208 29.5 29.5S103.292 80.5 87 80.5z",
          fill: "#CCC",
          fillOpacity: 0.787,
          opacity: 0.906,
          stroke: "#CCC"
        }), /*#__PURE__*/_jsx("path", {
          d: "M68.52 117.531l-2.75 19.781h43.46l-2.75-19.78H68.52z",
          stroke: "#CCC",
          fill: "#F5F5F5"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#CCC",
          fill: "#F5F5F5",
          d: "M50.462 135.031h75.164v4.469H50.462z"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M96.83 61.612V61a1 1 0 00-1-1h-6.66a1 1 0 00-1 1v.612H84a1 1 0 00-1 1V80a1 1 0 001 1h7.522a.591.591 0 100-1.182h-7.32V62.795h3.969v.46a1 1 0 001 1h6.658a1 1 0 001-1v-.46h3.968v7.955a.601.601 0 101.203 0v-8.138a1 1 0 00-1-1h-4.17zm-1.203 1.462h-6.254v-1.892h6.254v1.892zm-7.947 7.752h5.552a.591.591 0 110 1.182H87.68a.591.591 0 110-1.182zm9.64-2.38h-9.64a.591.591 0 010-1.183h9.64a.591.591 0 110 1.182zm.712 7.47h3.377a.591.591 0 110 1.183h-3.377v3.3a.601.601 0 01-1.203 0v-3.3h-3.377a.591.591 0 110-1.182h3.377v-3.3a.601.601 0 111.203 0v3.3z",
        fill: "#CCC",
        fillRule: "nonzero"
      }), /*#__PURE__*/_jsx("g", {
        fill: "#CCC",
        fillRule: "nonzero",
        children: /*#__PURE__*/_jsx("path", {
          d: "M156.2 79.733a.634.634 0 010 1.267h-11.4a.634.634 0 010-1.267h11.4zM156.833 62c1.748 0 3.167 1.325 3.167 2.955V75.51c-.003 1.63-1.422 2.955-3.167 2.955h-12.666c-1.745 0-3.167-1.325-3.167-2.954V64.955c0-1.63 1.422-2.955 3.167-2.955h12.666zm0 1.267h-12.666c-1.049 0-1.9.757-1.9 1.688V75.51c0 .93.851 1.688 1.9 1.688h12.665c1.05 0 1.9-.757 1.9-1.688V64.955c.001-.93-.85-1.688-1.899-1.688zm-9.047 4.75c1.099 0 1.77.514 3.122 2.007l.255.282c1.018 1.118 1.507 1.484 2.05 1.484.919 0 1.622-.355 2.173-1.097a.674.674 0 01.95-.138c.3.23.36.657.135.96-.807 1.088-1.913 1.647-3.257 1.647-1.1 0-1.771-.514-3.123-2.007l-.254-.282c-1.02-1.118-1.508-1.484-2.051-1.484-1.06 0-1.71.493-2.07 1.589a.677.677 0 01-.86.434.688.688 0 01-.429-.868c.543-1.648 1.704-2.527 3.359-2.527z"
        })
      }), /*#__PURE__*/_jsxs("g", {
        fill: "#CCC",
        fillRule: "nonzero",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M275.732 64.616h-.349V62.25c0-.69-.567-1.25-1.268-1.25h-14.847c-.7 0-1.268.56-1.268 1.25v17.5c0 .69.568 1.25 1.268 1.25h16.464c.7 0 1.268-.56 1.268-1.25V65.866c0-.69-.568-1.25-1.268-1.25zm-1.617-2.366v2.366h-14.847v-.76h10.169c.22-.019.388-.2.388-.417a.421.421 0 00-.388-.417h-10.17v-.772h14.848zm1.617 17.5h-16.464V65.866h16.464v3.784h-6.295a.853.853 0 00-.599.244.828.828 0 00-.248.59v4.65c0 .221.09.433.249.59a.85.85 0 00.598.242h6.295v3.784zm0-4.616h-6.295v-4.65h6.295v4.65z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M271.454 63.998h1.164c.216-.022.382-.239.382-.498 0-.26-.166-.476-.382-.498h-1.164c-.157-.016-.309.075-.392.236a.585.585 0 000 .524c.083.161.235.252.392.236zM271 72a1 1 0 102 0 1 1 0 00-2 0z"
        })]
      }), /*#__PURE__*/_jsxs("g", {
        fill: "#CCC",
        fillRule: "nonzero",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M210.472 81a9.328 9.328 0 004.596-1.18.691.691 0 00.392-.619.802.802 0 00-.336-.674.83.83 0 00-.729 0c-1.177.674-2.522 1.011-3.923 1.011-4.427 0-8.014-3.597-8.014-8.038a8.057 8.057 0 017.286-8.038V71.5c0 .393.336.73.728.73h8.8a.743.743 0 00.728-.73c0-5.228-4.26-9.5-9.472-9.5s-9.527 4.272-9.527 9.5c-.056 5.228 4.203 9.5 9.471 9.5zm8.015-10.23H211.2v-7.308c3.867.337 6.893 3.429 7.286 7.307z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M217.115 75.462c-.232.44-.542.88-.93 1.256-.309.377-.231.88.233 1.131.465.252 1.084.189 1.394-.188.387-.503.774-.943 1.083-1.508.233-.377.078-.88-.464-1.068-.465-.189-1.084-.063-1.316.377z"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M325.01 75.194h-4.72a.654.654 0 01-.662-.645c0-.356.297-.645.662-.645h5.13a5.358 5.358 0 00-.41 1.29zm2.412-4.84c.648.302 1.031.418 1.243.642a5.64 5.64 0 00-1.719.95h-5.993s-.005.117-.002-.167c-.002-.948.344-.903 1.463-1.425.382-.178 1.588-.7 1.588-.7s.06-.267 0-.467c-.285-.161-.576-.874-.611-1.168-.265-.117-.343-.612-.367-.7-.021-.083.024-.32.201-.334a1.515 1.515 0 01-.079-.484c0-.04.003-.078.007-.117a1.367 1.367 0 01-.007-.117c0-.902.793-1.401 1.77-1.401.979 0 1.772.498 1.772 1.401 0 .04-.004.078-.007.117.003.039.007.077.007.117 0 .168-.028.331-.08.484.178.014.223.251.201.333-.023.089-.102.584-.366.7-.036.295-.326 1.008-.611 1.169a.864.864 0 000 .467s1.208.523 1.59.7zm6.092 1.162V62.29h-17.192v15.485h8.844c.145.46.354.89.61 1.29h-9.454c-.73 0-1.322-.577-1.322-1.29V62.29c0-.713.592-1.29 1.322-1.29h17.192c.73 0 1.322.577 1.322 1.29v10.341a5.617 5.617 0 00-1.322-1.115zm.253 8.37a4.733 4.733 0 01-3.006 1.066c-2.587 0-4.683-2.046-4.683-4.57 0-2.524 2.096-4.57 4.683-4.57 2.586 0 4.682 2.046 4.682 4.57 0 .932-.286 1.8-.777 2.522l1.101.934a.657.657 0 01.07.933.674.674 0 01-.944.07l-1.126-.955zm-3.006-.212c1.863 0 3.373-1.474 3.373-3.292 0-1.819-1.51-3.293-3.373-3.293-1.864 0-3.374 1.474-3.374 3.293 0 1.818 1.51 3.292 3.374 3.292z",
        fill: "#CCC",
        fillRule: "nonzero"
      })]
    })]
  }));
}

ErrorComponent.displayName = "ErrorComponent";
export default ErrorComponent;
//# sourceMappingURL=es/ErrorComponent.js.map